export default "__VITE_ASSET__B4Irou3T__"